const paymentTypeEnum = Object.freeze({
    CASH_ON_DELIVERY: 1,
    E_WALLET        : 2,
    PAYPAL          : 3,
});
export default paymentTypeEnum;
